<template>
  <div class="flex flex-col items-center justify-center py-12 px-4">
    <div class="text-gray-400 mb-4">
      <svg class="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    </div>
    <h3 class="text-lg font-semibold text-gray-700 mb-2">Aucune donnée disponible</h3>
    <p class="text-gray-500 text-sm text-center mb-4" v-if="result?.message">
      {{ result.message }}
    </p>
    <button
      v-if="refresh"
      @click="refresh"
      class="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition"
    >
      Réessayer
    </button>
  </div>
</template>

<script setup>
defineProps({
  refresh: { type: Function, default: null },
  result: { type: Object, default: null }
})
</script>
